'use client'

export const runtime = 'edge'

import { LoginForm } from './LoginForm'
import { LoginFormContainer } from '@/components/login-form/login-form-container'

// Add dynamic export to prevent static generation
export const dynamic = 'force-dynamic'

export default function AdminLoginPage() {
  return (
    <LoginFormContainer
      title="Admin Login"
      description="WhatsApp Business API Administration"
    >
      <LoginForm />
    </LoginFormContainer>
  )
}
